import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "./CategoriaDocumento";
import DocumentoVersao from "./DocumentoVersao";
import { BaseModel } from "model/BaseModel";
import { DocumentoPasta } from "./DocumentoPasta";
import DocumentoAcao from "./acesso/DocumentoAcao";
import DocumentoHistoricoItem from "./DocumentoHistoricoItem";

export default class Documento implements BaseModel {
    id: number;
    codigo = "";
    codigoInterno: string;
    nome: string;
    categoria: CategoriaDocumento;
    usuarioCriacao: Usuario | null;
    usuarioResponsavel: Usuario | null;
    versaoInicial: number;
    confirmacaoLeitura: boolean;
    diasConfirmacaoLeitura: number;
    controlaPrazo: boolean;
    mesesPrazo: number;
    alertaVencimento : boolean;
	diasAlertaVencimento : number;
    internoExterno: string;
    observacao: string;
    disposicao: string;
    retencao: string;
    recuperacao: string;
    protecao: string;
    armazenamento: string;
    formaAcesso: string;
    status: string;
    tipoGestao: string = "CONTROLADO";
    temAlgumAcesso: boolean;
    pastaMae: DocumentoPasta | null;
    versoes: DocumentoVersao[];
    versaoVigente: DocumentoVersao | null;
    itensHistorico: DocumentoHistoricoItem[] = [];
    acoesUsuarioLogado: DocumentoAcao[] = []

    constructor(
        id: number = 0,
        codigoInterno: string = "",
        nome: string = "",
        categoria: CategoriaDocumento = new CategoriaDocumento(),
        usuarioCriacao: Usuario|null = null,
        usuarioResponsavel: Usuario|null = null,
        versaoInicial: number = 0,
        confirmacaoLeitura: boolean = false,
        diasConfirmacaoLeitura: number = 0,
        controlaPrazo: boolean = false,
        mesesPrazo: number = 0,
        alertaVencimento: boolean = false,
        diasAlertaVencimento: number = 0,
        internoExterno: string = "INTERNO",
        observacao: string = "",
        disposicao: string = "",
        retencao: string = "",
        recuperacao: string = "",
        protecao: string = "",
        armazenamento: string = "",
        formaAcesso: string = "",
        status: string = "EM_ELABORACAO",
        temAlgumAcesso: boolean = false,
        pastaMae: DocumentoPasta | null = new DocumentoPasta(0, '(Raiz)', null),
        versoes: DocumentoVersao[] = [],
        versaoVigente: DocumentoVersao|null = null
    ) {
        this.id = id;
        this.codigoInterno = codigoInterno;
        this.nome = nome;
        this.categoria = categoria;
        this.usuarioCriacao = usuarioCriacao;
        this.usuarioResponsavel = usuarioResponsavel;
        this.versaoInicial = versaoInicial;
        this.confirmacaoLeitura = confirmacaoLeitura;
        this.diasConfirmacaoLeitura = diasConfirmacaoLeitura;
        this.controlaPrazo = controlaPrazo;
        this.mesesPrazo = mesesPrazo;
        this.alertaVencimento = alertaVencimento;
        this.diasAlertaVencimento = diasAlertaVencimento;
        this.internoExterno = internoExterno;
        this.observacao = observacao;
        this.disposicao = disposicao;
        this.retencao = retencao;
        this.recuperacao = recuperacao;
        this.protecao = protecao;
        this.armazenamento = armazenamento;
        this.formaAcesso = formaAcesso;
        this.status = status;
        this.temAlgumAcesso = temAlgumAcesso;
        this.pastaMae = pastaMae;
        this.versoes = versoes;
        this.versaoVigente = versaoVigente;
    }
}
